import React from "react";
import { useReserve } from "../Hooks";
import ReserveSlider from "./ReserveSlider";
import Loading from "../../../Common/Loading";

const ReserveBox = ({ data, loading, renderCategory }) => {
  const { getDataByCity } = useReserve();

  if (loading) {
    return (
      <div className="row">
        <Loading count={4} height={346} />
      </div>
    );
  }
  if (renderCategory().city) {
    return (
      <>
        {data &&
          data.data &&
          data.data.map(category => {
            return (
              <ReserveSlider
                key={category.id}
                data={category.items}
                category={category}
                city={category}
              />
            );
          })}
      </>
    );
  }
  return (
    <>
      {data &&
        data.cities &&
        data.cities.map(city => {
          return (
            <ReserveSlider
              key={city.id}
              city={city}
              data={getDataByCity(city.id, data.data)}
            />
          );
        })}
    </>
  );
};

export default ReserveBox;
